"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.isProjectedContainerOutput = exports.PROJECTED_CONTAINER_ARTIFACT_COUNT = exports.DeliverableGenerateReceiptWorkleaseSchema = exports.DeliverablesCreateZipFilesWorkleaseSchema = exports.DeliverableContainerGenerateReceiptStatuses = exports.COMPLETION_SWEEP_HORIZON_DAYS = exports.SCHEDULE_NOT_SET_DATE = exports.DAYS_BEFORE_DUE_DATE = exports.isBusContainerType = exports.DeliverableContainerTypes = exports.DeliverableTypes = exports.v3DEPRECATED = exports.v2DEPRECATED = void 0;
const zod_1 = require("zod");
// Re-export deprecated namespaces as modules
exports.v2DEPRECATED = __importStar(require("./Deliverable/v2DEPRECATED"));
exports.v3DEPRECATED = __importStar(require("./Deliverable/v3DEPRECATED"));
// ___________ CONFIG TYPES ___________
exports.DeliverableTypes = [
    'monthlyServicerReportXlsx',
    'loanTape',
    'repaymentTape',
    'supplementalTape',
    'cashBalancesFeed',
    'portfolioCovenant',
    'orgProvidedInput', // 'other' type for special customer input
    'monthlyStatement',
    'financialStatement',
    'financialCovenant',
];
exports.DeliverableContainerTypes = [
    'settlementReport', // MSR (just removing the cadence)
    'borrowingBaseCertificate', // domain isn't supported yet
    'complianceCertificate', // domain isn't supported yet
    'financials', // domain isn't supported yet
    'budgetsAndProjections', // domain isn't supported yet
    'other', // domain isn't supported yet
    'backupServicingCycle', // BUS: the monthly tape + MSR a servicing cycle reconciles
    'backupServicingDataTape', // BUS: a tape-only (e.g. daily) delivery, no reconcile
];
/**
 * BUS containers track each input's LATEST attempt (any status) through its
 * processing chain, rather than the latest success. See
 * docs/bus/reference/cycles-and-deliverables.md §4.5.
 */
const isBusContainerType = (containerType) => containerType === 'backupServicingCycle' ||
    containerType === 'backupServicingDataTape';
exports.isBusContainerType = isBusContainerType;
exports.DAYS_BEFORE_DUE_DATE = 30;
/**
 * Far-future `startDate` / `endDate` for a `recurringDueDateConfig` whose real
 * schedule hasn't been set yet (e.g. a template CA, and the clones copied from it).
 * It produces no due dates, so nothing materializes until an admin sets the
 * deal's actual dates.
 */
exports.SCHEDULE_NOT_SET_DATE = '2099-12-31';
/**
 * The daily completion sweep skips containers due more than this many days ago; they
 * would otherwise be re-scanned forever. It only stops the sweep: an on-demand refresh
 * still completes a container of any age, and old containers still list.
 */
exports.COMPLETION_SWEEP_HORIZON_DAYS = 90;
// generate receipt table
exports.DeliverableContainerGenerateReceiptStatuses = [
    'initialized',
    'inProgress',
    'success',
    'error',
];
// Zod schema for DeliverablesCreateZipFilesWorklease
exports.DeliverablesCreateZipFilesWorkleaseSchema = zod_1.z.object({
    receiptId: zod_1.z.string(),
    organizationId: zod_1.z.string(),
    creditFacilityId: zod_1.z.string(),
});
// Zod schema for DeliverableGenerateReceiptWorklease
exports.DeliverableGenerateReceiptWorkleaseSchema = zod_1.z.object({
    generateReceiptId: zod_1.z.string(),
});
/**
 * The artifact counts a projected container (computed from the CA config, not yet
 * persisted) carries in place of real ones. Its `id` is a throwaway uuid.
 */
exports.PROJECTED_CONTAINER_ARTIFACT_COUNT = -1;
const isProjectedContainerOutput = (container) => container.totalDependencies === exports.PROJECTED_CONTAINER_ARTIFACT_COUNT;
exports.isProjectedContainerOutput = isProjectedContainerOutput;
//# sourceMappingURL=Deliverable.js.map